<template>
	<div class="register">
		<div class="title-name">查询前请选择医院及就诊人</div>
		<div class="drop-box">
			<!-- <a-dropdown :overlayStyle="style">
        <a class="ant-dropdown-link">
          {{ HospitalName }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item
            v-for="item in hospitalSelectOptions"
            :key="item.id"
            @click="changeHospital(item)"
          >
            <a href="javascript:;">{{ item.name }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown> -->
			<a-select
				show-search
				:placeholder="HospitalName"
				option-filter-prop="children"
				style="width: 400px"
				:filter-option="filterOption"
				@change="handleChange"
			>
				<a-select-option
					v-for="item in hospitalSelectOptions"
					:key="item.id"
					:value="item.id"
				>
					{{ item.name }}
				</a-select-option>
			</a-select>

			<a-dropdown>
				<a class="ant-dropdown-link">
					{{ patientName }}
					<a-icon type="down" />
				</a>
				<a-menu slot="overlay">
					<a-menu-item
						v-for="it in patientOptions"
						:key="it.cardNo"
						@click="changePatient(it)"
					>
						<a href="javascript:;">{{ it.name }}</a>
					</a-menu-item>
				</a-menu>
			</a-dropdown>
		</div>
		<template v-if="reserveList.length > 0">
			<div class="card-box" ref="father">
				<a-card
					class="card-info"
					v-for="(item, index) in reserveList"
					:key="index"
					@click="goNext(item.id)"
				>
					<span
						slot="title"
						style=" font-size: 18px; font-weight: 400; color: #666666;"
						>订单号：{{ item.code }}</span
					>
					<span
						slot="extra"
						style=" font-size: 18px; font-weight: 400; color: #666666;"
						>{{ item.status | reserveStatus }}</span
					>
					<div class="cont-info">
						<div class="doctor-info">
							<div class="hospitalImg hp_center">
								<img
									v-if="item.image"
									:src="base_url + item.image"
									alt
								/>
								<img
									v-else
									src="@/assets/default-img/doctor.png"
									alt
								/>
							</div>
							<div class="doctor-title">
								<span style="margin:8px 0;">
									<span style="color:#333333">{{
										item.doctorName
									}}</span>
									{{ item.deptName }}
								</span>
								<span style="font-size:13px">{{
									item.hospitalName
								}}</span>
							</div>
						</div>
						<div class="patient-box">
							<span>
								<span class="patient-title">就诊人：</span>
								<span class="patient-name">{{
									item.recordName
								}}</span>
							</span>
							<span>
								<span class="patient-title">挂号费用：</span>
								<span style="color:#FF8400">{{
									item.payAmount
								}}</span>
								<span class="patient-name">元</span>
							</span>
						</div>
						<div class="patient-box">
							<span>
								<span class="patient-title">就诊时间：</span>
								<span class="patient-name">{{
									item.treatTime
								}}</span>
							</span>
						</div>
					</div>
					<div class="card-footer">
						<span v-if="item.exprieTime > 0">
							<span style="color:#FF0000">{{
								inittime(item.exprieTime)
							}}</span
							>s内未支付将自动取消订单
						</span>
						<span v-else></span>
						<div class="right-btn">
							<!-- 退款颜色background: #fff;border:1px solid #ccc;color:#ccc; -->
							<!-- <div v-if="item.status == 0" style=" background: #459DF7;">未支付</div>
              <div v-if="item.status == 1" style=" background: #459DF7;">退款</div>
              <div v-if="item.status == 2" style="margin-right:12px">已退款</div>
              <div v-if="item.status == 3" style="margin-right:12px">已取消</div>
              <div v-if="item.status == 4" style=" background: #fea762;">退款中</div>
              <div v-if="item.status == 5" style=" background: #fea762;">已过期</div>
              <div v-if="item.status == 6" style=" background: #fea762;">退款失败</div>
              <div v-if="item.status == 10" style=" background: #fea762;">已完成</div>-->
							<div
								:style="divTxt(item).css"
								@click.stop="refund(item, divTxt(item).type)"
							>
								{{ divTxt(item).text }}
							</div>
						</div>
					</div>
				</a-card>
			</div>
			<div>
				<a-pagination
					show-quick-jumper
					:current="currPage"
					:total="totalCount"
					:defaultPageSize="form.pageSize"
					@change="onChange"
				/>
				<br />
			</div>
		</template>
		<noData v-else></noData>
	</div>
</template>
<script>
import {
	hospitalSelect,
	reserve,
	byHospId,
	getUserinured,
	saveUserinured,
} from '@/api/register'
import { ls } from '@/utils/tool'
import { cancel } from '@/api/registered'
import { startRefund } from '@/api/payment'
import noData from '@/components/NoData'
var jsTime
export default {
	components: {
		noData,
	},
	data() {
		return {
			hospitalSelectOptions: [],
			patientOptions: [],
			HospitalName: '',
			patientName: '',
			hospitalId: '',
			cardNo: '',
			reserveList: [],
			form: {
				cardNo: '',
				hospitalId: '',
				pageNum: 1,
				pageSize: 6,
			},
			currPage: 1,
			totalCount: 1,
			style: {
				maxHeight: '430px',
				overflow: 'scroll',
				overflowX: 'hidden',
			},
			recordId: '',
		}
	},
	created() {
		console.log(this.$route)
		this.getData()
	},
	mounted() {},
	methods: {
		handleChange(value) {
			this.hospitalId = value
			this.currPage = 1
			this.getReserve()
		},
		// handleBlur() {
		//   console.log("blur");
		// },
		// handleFocus() {
		//   console.log("focus");
		// },
		filterOption(input, option) {
			return (
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
			)
		},

		onChange(pageNumber) {
			this.form.pageNum = pageNumber
			this.getReserve()
		},
		async getData() {
			getUserinured({
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
			})
				.then((res) => {
					this.HospitalName = this.$route.query.HospitalName
						? this.$route.query.HospitalName
						: res.data.hospital.name
					this.hospitalId = this.$route.query.hospitalId
						? this.$route.query.hospitalId
						: res.data.hospital.id
					this.patientName = this.$route.query.patientName
						? this.$route.query.patientName
						: res.data.record.name
					this.recordId = res.data.record.id
				})
				.catch(async () => {
					//医院下拉列表
					let res = await hospitalSelect()
					this.hospitalSelectOptions = res.data || []
					this.HospitalName =
						this.$route.query.HospitalName || res.data[0].name
					this.hospitalId =
						this.$route.query.hospitalId || res.data[0].id
					this.patientName =
						this.$route.query.patientName ||
						this.patientOptions[0].name
				})
				.finally(() => {
					hospitalSelect().then((res) => {
						this.hospitalSelectOptions = res.data
					})
					//获取就诊人列表
					this.patientOptions = JSON.parse(
						localStorage.getItem('sysUser')
					).relationRecords
					if (!this.patientName) {
						this.patientName =
							this.$route.query.patientName ||
							this.patientOptions[0].name
					}
					this.patientOptions.forEach((item) => {
						if (item.name == this.patientName) {
							this.cardNo = item.cardNo
							this.recordId = item.recordId
						}
					})
					if (this.patientOptions.length) this.getReserve()
				})
		},
		//获取挂号记录
		async getReserve() {
			let { data, code } = await byHospId(this.hospitalId)
			this.needPay = code == 200 ? data.needPay : 0

			this.form.cardNo = this.cardNo
			this.form.hospitalId = this.hospitalId
			let res = await reserve(this.form)
			console.log('res========', res)
			if (res.code == 500) {
				this.$message.error(res.message)
				// ls.cl()
				// this.$router.push({ path: '/login' })
			}
			if (res.code == 200) {
				//exprieTime剩余时间 s
				this.reserveList = res.data.list
				// let time = new Date(res.data.list[0].treatTime.substr(0,10))
				// let newtime = new Date()
				// console.log(time,newtime)
				this.totalCount = res.data.totalCount
				this.currPage = res.data.currPage
				//如果需要开启倒计时则打开此代码
				clearInterval(jsTime)
				jsTime = setInterval(() => {
					this.reserveList.forEach((item) => {
						if (item.exprieTime != 0) {
							item.exprieTime--
							if (item.exprieTime == 0) {
								this.getData()
							}
						}
					})
				}, 1000)
			} else {
				this.reserveList = []
				this.totalCount = 0
				this.currPage = 1
			}
			console.log('查看档案', this.form)
			saveUserinured({
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
				hospitalId: this.hospitalId,
				recordId: this.recordId,
			})
		},
		//选择医院
		changeHospital(val) {
			this.HospitalName = val.name
			this.hospitalId = val.id
			this.currPage = 1
			this.getReserve()
		},
		//选择就诊人
		changePatient(val) {
			this.patientName = val.name
			this.cardNo = val.cardNo
			this.recordId = val.recordId
			this.currPage = 1
			this.getReserve()
		},
		//前往下个页面
		goNext(id) {
			this.$router.push({
				path: '/user-center/register/register-detail',
				query: {
					id: id,
					hospId: this.hospitalId,
				},
			})
		},
		//计算返回的对象
		divTxt(item) {
			let obj = {}
			//市一医院个需
			// if (item.hospitalName == "淮南市第一人民医院") {
			//   if (this.calcDay(item.treatTime, false)) {
			//     return this.setDate("再次预约", "#FEA762;", 2);
			//   } else {
			//     if (item.status == 0 || item.status == 1) {
			//       return this.setDate("取消预约", "#FF0000;", 1);
			//     }
			//     return this.setDate("再次预约", "#FEA762;", 2);
			//   }
			// }
			if (this.calcDay(item.treatTime) && item.status != 2) {
				//超时就全部显示再次预约
				return this.setDate('再次预约', '#FEA762;', 2)
			} else {
				if (this.needPay == 2) {
					if (item.status == 0 || item.status == 1) {
						return this.setDate('取消预约', '#FF0000;', 1)
					}
					return this.setDate('再次预约', '#FEA762;', 2)
				}

				if (item.handSchFlg == '1') {
					//1为人工排班
					//人工排班时status为0时为取消预约
					if (item.status == 0 || item.status == 1) {
						return this.setDate('取消预约', '#FF0000', 1)
					}
					return this.setDate('再次预约', '#FEA762', 2)
				}
				switch (item.status) {
					case 0:
						obj = this.setDate('去支付', '#2b85e4', 4)
						break
					case 1:
						if (item.payAmount == 0) {
							obj = this.setDate('取消预约', '#FF0000', 1)
						} else {
							obj = this.setDate(
								'退款',
								'?background: #fff;color:#797979;border:1px solid #ccc',
								3
							)
						}
						break
					case 2:
						obj = this.setDate('已退款', '', 2)
						break
					case 3:
						obj = this.setDate('再次预约', '#fea762', 2)
						break
					case 4:
						obj = this.setDate('退款中', '#fea762', 'null')
						break
					case 5:
						obj = this.setDate('再次预约', '#fea762', 2)
						break
					case 6:
						obj = this.setDate('退款失败', '#ff0000', 'null')
						break
					case 9:
						obj = this.setDate('已就诊', '#fea762', 'null')
						break
					case 10:
						obj = this.setDate('已完成', '#fea762', 'null')
						break
				}
			}
			return obj
		},
		// 优化下obj的显示
		setDate(text, css, type) {
			let obj = { text }
			if (css.indexOf('?') == -1) {
				obj.css = 'background:' + css
			} else {
				obj.css = css.substr(1)
			}
			if (type != 'null') {
				obj.type = type
			}
			return obj
		},
		//判断时间是否过期 过期返回true
		calcDay(val, one = true) {
			//one为针对第一人民医院的时间筛选开关 false表示为第一人民医院
			let day = new Date().getTime()
			let oldday
			if (one) {
				oldday = new Date(val.substr(0, 10)).getTime()
			} else {
				oldday = new Date(val.substr(20)).getTime()
			}
			if (day - oldday > 86400000) {
				return true
			}
			return false
		},
		async refund(item, type) {
			// 1为取消预约
			if (type == 1) {
				let res = await cancel(item.id)
				if (res.code == 200) {
					this.$message.success('成功取消预约')
					this.getData()
					return
				}
				this.$message.error(res.message)
			} else if (type == 2) {
				//2为再次预约
				this.$router.push({
					path: `/registered/doctor/${item.doctorId}/0`,
				})
			} else if (type == 3) {
				// 3为退款
				let data = { id: item.id }
				let res = await startRefund(data)
				if (res.code !== 200) {
					this.$message.error(res.message)
				} else {
					this.$message.success('退款成功')
					this.getData()
				}
			} else if (type == 4) {
				// 4为未支付，前往支付
				this.$router.push({
					name: 'payment',
					query: {
						id: item.id,
					},
				})
			}
			// if (item.status == 1 && item.payAmount == 0) {
			//   if (this.calcDay(item.treatTime)) {
			//     this.$router.push({
			//       path: `/registered/doctor/${item.doctorId}/0`,
			//     });
			//     return;
			//   }
			//   // console.log("这是要取消预约");
			//   let res = await cancel(item.id);
			//   if (res.code == 200) {
			//     this.$message.success("成功取消预约");
			//     this.getData();
			//     return;
			//   }
			//   this.$message.error(res.message);
			// }
			// if (item.status == 1 && item.payAmount != 0) {
			//   // console.log("这是要退款");
			//   let data = { id: item.id };
			//   let res = await startRefund(data);
			//   if (res.code !== 200) {
			//     this.$message.error(res.message);
			//   } else {
			//     this.$message.success("退款成功");
			//     this.getData();
			//   }
			// }
			// if (item.status == 3) {
			//   // console.log("这是再次预约");
			//   this.$router.push({
			//     path: `/registered/doctor/${item.doctorId}/0`,
			//   });
			// }
			// if (item.status == 0) {
			//   this.$router.push({
			//     name: "payment",
			//     query: {
			//       id: item.id,
			//     },
			//   });
			// }
		},
		inittime(leftTime) {
			var m, s, h
			if (leftTime >= 0) {
				m = this.formatNum(Math.floor((leftTime / 60) % 60))
				s = this.formatNum(Math.floor(leftTime % 60))
				if (leftTime > 3600) {
					h = this.formatNum(Math.floor(leftTime / 3600) % 60)
				} else {
					return m + ':' + s
				}
			} else {
				h = '00'
				m = '00'
				s = '00'
			}
			return h + ':' + m + ':' + s
		},
		formatNum(num) {
			return num < 10 ? '0' + num : '' + num
		},
	},
	beforeDestroy() {
		clearInterval(jsTime)
	},
}
</script>
<style lang="less" scoped>
.register {
	.title-name {
		font-size: 20px;
		font-weight: 400;
		color: #3385ed;
	}
	.drop-box {
		margin-top: 22px;
		a {
			background: #f9f9f9;
			border: 1px solid #eeeeee;
			border-radius: 4px;
			padding: 13px 16px;
			font-size: 16px;
			font-weight: 400;
			color: #3385ed;
			i {
				margin-left: 50px;
			}
		}
		a:first-child {
			margin-right: 50px;
		}
	}
	.ant-select {
		background: #f9f9f9;
		margin-right: 50px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		padding: 7px 16px;
		font-size: 16px;
		font-weight: 400;
		/deep/.ant-select-selection--single {
			background: #f9f9f9;
			border: 0;
			.ant-select-selection__placeholder {
				color: #3385ed;
			}
			.ant-select-selection-selected-value {
				color: #3385ed;
			}
		}
	}
	.card-box {
		margin-top: 25px;
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 30px;
		.card-info {
			cursor: pointer;
			width: 412px;
			// height: 255px;
			background: #ffffff;
			box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
			border-radius: 20px;
			padding: 15px;
			margin-bottom: 55px;
			.cont-info {
				border-bottom: 1px solid #d5d5d5;
				height: 200rpx;
				padding: 10px 0;
				.doctor-info {
					display: flex;
					.hospitalImg {
						width: 62px;
						height: 62px;
						margin-right: 25px;
						overflow: hidden;
						border-radius: 50%;
						img {
							height: 62px;
						}
					}
					.doctor-title {
						display: flex;
						flex-direction: column;
						font-size: 18px;
						font-weight: 400;
						color: #999999;
					}
				}
				.patient-box {
					display: flex;
					justify-content: space-between;
					font-size: 18px;
					margin-top: 8px;
					.patient-title {
						font-weight: 400;
						color: #333333;
					}
					.patient-name {
						color: #666;
					}
				}
			}
			/deep/ .ant-card-head {
				padding: 0;
			}
			/deep/ .ant-card-body {
				padding: 0;
			}
		}
		.card-info:nth-child(odd) {
			margin-right: 40px;
		}
		.card-footer {
			padding-top: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			span {
				font-size: 13px;
				font-weight: 400;
				color: #999;
			}
			.right-btn {
				display: flex;
				user-select: none;
				padding: 2px;
				div {
					background: #b3b6ba;
					border-radius: 10px;
					text-align: center;
					line-height: 34px;
					color: #fff;
					padding: 4px;
				}
			}
		}
		.next-page {
			margin-left: 480px;
			/deep/ li {
				width: 50px;
				height: 50px;
				line-height: 50px;
			}
		}
	}
}
.btn_item {
	width: 0.4rem;
}
</style>
